/*eslint-disable */
import { bus } from '@/main';
var $ = window.jQuery = require('jquery');
import addRlistUser from '@/components/add-rlist-user';
import countries from '@/services/country.json'
import toast from '@/services/toast';
import {
mapGetters,
} from 'vuex';
export default {
name: 'rlist-users',
components: {
  'add-rlist-user': addRlistUser,
},
props: [],
data () {
  return {
    rListUsersData:null,
    rListUsersDataResults:[],
    userCreateform:false,
    countryList:[],
    selectedUserId:'',
    removeUserPopup:false,
    updateInfoOfUserId:''
  }
},
computed: {
  ...mapGetters([
    'getRListUsersGetters',
  ]),
  getAllUserLogInfo(){
    this.rListUsersData = this.$store.getters.getRListUsersGetters.data;
    return;
  },
  setIntialStateAllUser(){
    if(this.rListUsersData){
      this.rListUsersDataResults =  this.rListUsersData.results
    }
    return;
  },
},
mounted () {
  Object.keys(countries).map((key, index) => {
    this.countryList.push({
      name: countries[key].toLowerCase(),
      value: key.toLowerCase()
    })
  });
  this.getAllUserLogInfo
  this.setIntialStateAllUser
  bus.$on('HideAddUserPopup', (data) => {
    this.userCreateform = data;
    this.updateInfoOfUserId = ''
  });
},
methods: {
  getUserListAgain() {
    this.$store.dispatch('getRListUsersFun')
  },
  addRlistUserMethod(){
    this.userCreateform = true;
    $('body').addClass('body_right_scroll_remove')
  },
  editRListUserMethod(userId){
    this.updateInfoOfUserId = userId;
    this.userCreateform = true;
    $('body').addClass('body_right_scroll_remove')
  },
  getCountryFlag: function(countryCode, type) {
    if (countryCode == null) {
      countryCode = ''
    }
    let countryName = countryCode.toLowerCase()
    let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
    if (country && country.length > 0) {
      country = country[0]
      if (type == 'flag') {
        country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/flags/${country.value}.svg`
      } else {
        country = country.name
      }
    } else {
      country = ''
    }
    return country;
  },
  removeUserConfirmation(userId) {
    this.selectedUserId = userId;
    this.removeUserPopup = true
    $('body').addClass('body_right_scroll_remove')
  },
  removeModalItemConfirmFun(){
    this.$store.dispatch('removeRListUserFun', {
      id: this.selectedUserId,
    })
    .then((res) => {
      if (res.status == '200') {      
        toast.success(res.data.msg); 
        this.getUserListAgain();
        this.closeRemoveItemModalFun();
      }
    }).catch((err) => {
      toast.error(err.data.user_msg);  
    })
  return;
  },
  closeRemoveItemModalFun(){
    $('body').removeClass('body_right_scroll_remove')
    this.removeUserPopup = false
    this.selectedUserId = ''
  },
},
watch: {
  getAllUserLogInfo(){
    return this.$store.getters.getRListUsersGetters
  },
  setIntialStateAllUser(){
    if(this.rListUsersData){
      this.rListUsersDataResults =  this.rListUsersData.data
    }
    return;
  },
},
}